// 色彩
export enum EColor {
  // 强调色
  accent = "#f50",
  // 事物进行中
  underway = "#108ee9",
  // 正常状态
  nomarl = "#aaa",
  // 完成 | 成功
  completed = "#52c41a"
}
